import { Filter } from "./filter";

type TimeSheetFilter = Filter & {
  minDate: string;
  maxDate: string;
  includeDeactivated?: boolean;
  includeRemovedFromProject?: boolean;
  includeCompletedTasks?: boolean;
  includeProjectsWithoutSpentTime?: boolean;
  includeProjectsWithoutSpentTimeInWeek?: boolean;
  includeProjectsWithoutNonIntegratedSpentTimeInWeek?: boolean;
  integrationScope?: "PROJECT" | "RESOURCE";
  filterByResourceIntegrationDate?: boolean;
  filterByProjectIntegrationDate?: boolean;
};

const timeSheetFilter: TimeSheetFilter = {
  minDate: "",
  maxDate: "",
};

export type { TimeSheetFilter };

export { timeSheetFilter };
